<template>
  <CreateEditRoleForm @submit="onSubmit" />
</template>

<script setup lang="ts">
const router = useRouter()

const onSubmit = () => router.push({ name: "roleIndex" })
</script>
